import { combineReducers } from 'redux'
import anonymizerReducer from './anonymizer/redux'
import { reducer as esnMappingReducer } from './esn-mapping'
import { reducer as idMappingReducer } from './id-mapping'
import { reducer as ipGeolocationReducer } from './ip-geolocation'
import { reducer as onnetOffnetReducer } from './onnet-offnet'

export default combineReducers({
  idMapping: idMappingReducer,
  ipGeolocation: ipGeolocationReducer,
  onnetOffnet: onnetOffnetReducer,
  esnMapping: esnMappingReducer,
  anonymizer: anonymizerReducer,
})
